import React, { useState } from 'react';
import { Button, Card, Col, Form, Row, Modal, Spinner, Badge } from 'react-bootstrap';
import { BsSendFill, BsClockHistory, BsChevronRight } from 'react-icons/bs';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';


import notificacionesServices from '../../../Services/Notificaciones/notificaciones.services';

type Bloque = 'AM' | 'PM';

export default function NotificacionRetardos() {
  const [bloque, setBloque] = useState<Bloque>('AM');
  const [loading, setLoading] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState('');
  const [toastHeader, setToastHeader] = useState('');
  const [toastColor, setToastColor] = useState<'success'|'danger'|'warning'|'info'|string>('info');
  

 
  const [showConfirm, setShowConfirm] = useState(false);

  
  const [accionPendiente, setAccionPendiente] = useState<'UNO' | 'AMBOS' | 'SEMANAL'>('UNO');


  
  const [historial, setHistorial] = useState<Array<{fecha: string; accion: string; resultado: 'OK'|'ERROR'; detalle: string}>>([]);

  const mostrarToast = (msg: string, header: string, color: typeof toastColor) => {
    setToastMsg(msg);
    setToastHeader(header);
    setToastColor(color);
    setShowToast(true);
  };

  const pushLog = (accion: string, resultado: 'OK'|'ERROR', detalle: string) => {
    setHistorial(prev => [
      { fecha: new Date().toLocaleString(), accion, resultado, detalle },
      ...prev.slice(0, 24) // limita a 25 últimos
    ]);
  };

  const confirmarEnvioUno = () => {
    setAccionPendiente('UNO');
    setShowConfirm(true);
  };

  const confirmarEnvioAmbos = () => {
    setAccionPendiente('AMBOS');
    setShowConfirm(true);
  };

  


  const ejecutarEnvio = async () => {
  setShowConfirm(false);
  setLoading(true);
  try {

    if (accionPendiente === 'UNO') {
      const { data } = await notificacionesServices.notificarRetardos(bloque);
      mostrarToast(data?.mensaje || 'Notificación enviada', 'Éxito', 'success');
      pushLog(`Notificar ${bloque}`, 'OK', data?.mensaje || 'OK');
    }

    else if (accionPendiente === 'AMBOS') {
      await notificacionesServices.notificarAmbos();
      mostrarToast('Se enviaron las notificaciones AM y PM', 'Éxito', 'success');
      pushLog('Notificar AM y PM', 'OK', 'Se enviaron ambos bloques');
    }

    else if (accionPendiente === 'SEMANAL') {
      const { data } = await notificacionesServices.notificarRetardosSemanalMTY();
      mostrarToast(data?.mensaje || 'Reporte semanal enviado', 'Éxito', 'success');
      pushLog('Notificar Semanal MTY', 'OK', data?.mensaje || 'OK');
    }

  } catch (e: any) {
    const err = e?.response?.data?.error || e?.message || 'Error desconocido';
    mostrarToast(`Error: ${err}`, 'Error', 'danger');
    pushLog(
      accionPendiente === 'UNO'
        ? `Notificar ${bloque}`
        : accionPendiente === 'AMBOS'
        ? 'Notificar AM y PM'
        : 'Notificar Semanal MTY',
      'ERROR',
      err
    );
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="mt-3">
      <Card>
        <Card.Body>
          <Row className="align-items-end g-3">
            <Col xs={12} md={3}>
              <Form.Label>Bloque</Form.Label>
              <Form.Select
                value={bloque}
                onChange={(e) => setBloque(e.target.value as Bloque)}
                disabled={loading}
              >
                <option value="AM">AM (10:30)</option>
                <option value="PM">PM (15:30)</option>
              </Form.Select>
              <Form.Text className="text-muted">
                La tarea automática corre a las 10:30 y 15:30 (America/Matamoros).
              </Form.Text>
            </Col>
            <Col xs={12} md="auto" className="mt-2">
          <Button
            variant="warning"
            onClick={() => { setAccionPendiente('SEMANAL'); setShowConfirm(true); }}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" animation="border" /> : <BsSendFill />}
            &nbsp;Enviar semanal MTY
          </Button>
        </Col>



            <Col xs={12} md="auto" className="mt-2">
              <Button
                variant="primary"
                onClick={confirmarEnvioUno}
                disabled={loading}
              >
                {loading ? <Spinner size="sm" animation="border" /> : <BsSendFill />}
                &nbsp;Enviar {bloque}
              </Button>
            </Col>

            <Col xs={12} md="auto" className="mt-2">
              <Button
                variant="success"
                onClick={confirmarEnvioAmbos}
                disabled={loading}
              >
                {loading ? <Spinner size="sm" animation="border" /> : <BsSendFill />}
                &nbsp;Enviar AM &nbsp;<BsChevronRight />&nbsp; PM
              </Button>
            </Col>

            <Col xs={12} md={5} className="mt-2">
              <Card bg="light" body>
                <div className="d-flex align-items-center gap-2">
                  <BsClockHistory />
                  <div>
                    <div className="fw-bold">Recordatorio</div>
                    <small>
                      Existe un <i>BackgroundService</i> que lo hace automático
                      (10:30 AM / 3:30 PM). Este módulo dispara manualmente.
                    </small>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Toast */}
      <MsgInformativo
        show={showToast}
        msg={toastMsg}
        header={toastHeader}
        msgColor={toastColor}
        closeToast={() => setShowToast(false)}
      />

      {/* Confirmación */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar envío</Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
  {accionPendiente === 'UNO' && (
    <>Vas a <b>enviar correos de retardos</b> para el bloque <Badge bg="secondary">{bloque}</Badge>. ¿Continuar?</>
  )}

  {accionPendiente === 'AMBOS' && (
    <>Vas a <b>enviar correos</b> para los bloques <Badge bg="secondary">AM</Badge> y <Badge bg="secondary">PM</Badge>. ¿Continuar?</>
  )}

  {accionPendiente === 'SEMANAL' && (
    <>Vas a <b>enviar el reporte SEMANAL de retardos (Monterrey)</b>. ¿Continuar?</>
  )}

  <div className="mt-2">
    <small className="text-muted">
      Esto ejecutará el endpoint del backend y enviará correos reales.
    </small>
  </div>
</Modal.Body>


        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={ejecutarEnvio} disabled={loading}>
            {loading ? <Spinner size="sm" animation="border" /> : 'Sí, enviar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Historial local */}
      <Card className="mt-3">
        <Card.Header className="d-flex align-items-center gap-2">
          <BsClockHistory /> Historial local de ejecuciones
        </Card.Header>
        <Card.Body>
          {historial.length === 0 ? (
            <small className="text-muted">Aún no hay ejecuciones en esta sesión.</small>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm align-middle">
                <thead>
                  <tr>
                    <th style={{width: '190px'}}>Fecha</th>
                    <th>Acción</th>
                    <th style={{width: '110px'}}>Resultado</th>
                    <th>Detalle</th>
                  </tr>
                </thead>
                <tbody>
                  {historial.map((h, i) => (
                    <tr key={i}>
                      <td>{h.fecha}</td>
                      <td>{h.accion}</td>
                      <td>
                        <Badge bg={h.resultado === 'OK' ? 'success' : 'danger'}>
                          {h.resultado}
                        </Badge>
                      </td>
                      <td>{h.detalle}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}
